(function($) {

	$(".c-products-row__item").click(function(){

		$(".c-products-row__item").removeClass("is-checked");
		$(this).addClass("is-checked");

	});

})(jQuery);

